import { createRoute } from "@tanstack/react-router";

import { ProtectedRoute } from "../auth/ProtectedRoute";
import { MurrayLabContent } from "../components/screens/MurrayLabContent";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/murray-lab",
  component: MurrayLabRoute,
});

function MurrayLabRoute() {
  return (
    <ProtectedRoute requiredRoles={["owner", "gm"]}>
      <MurrayLabContent />
    </ProtectedRoute>
  );
}
